import React from 'react'
import styled from 'styled-components'
import {Add} from '@mui/icons-material'
import {injectIntl} from 'react-intl'
import ModuleConfig from 'components/ModuleConfig'
import Dialog from 'components/Dialog'
import Confirmation from 'components/Confirmation'
import Modules from './Modules'

const Container = styled.div`
    background-color: ${props => props.mobile ? 'initial' : 'rgba(0, 0, 0, .4)'};
    top: 117px;
    position: ${props => props.mobile ? 'static' : 'absolute'};
    width: 100%;
`

const Plus = styled.button`
    padding: 0;
    background-color: rgba(255, 255, 255, .1);
    color: white;
    cursor: pointer;
    margin-left: auto;
    width: 30px;
    height: 30px;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;

    :hover {
        background-color: rgba(255, 255, 255, .3);
    }

    svg {
        color: rgba(255, 255, 255, .7);
        font-size: 16px;
    }
`

const Title = styled.div`
    ${props => props.mobile ?
        `
            text-transform: uppercase;
            color: #7c9198;
            font-family: Helvetica;
            font-weight: lighter;
            letter-spacing: 2px;
            font-size: 13px;
            padding: 30px 10px 10px 10px;
        `
        :
        `
            padding: 10px 20px;
            font-size: 16px;
            display: flex;
            align-items: center;
        `
    }
`

class ModulesList extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
            delete: false
        }
    }

    handleOpen = (type) => {
        this.setState({ open: type })
    }

    handleClose = () => {
        this.setState({
            open: false,
            delete: false
        })
    }

    handleOpenConfirmation = () => {
        this.setState({
            delete: true,
            open: false
        })
    }

    handleDelete = (id) => {
        this.props.deleteModule(id)
        this.handleClose()
    }

    render() {
        const { currentModule, permissions, mobile, updating, intl } = this.props

        return (
            <React.Fragment>
                <Container mobile={mobile}>
                    <Title mobile={mobile}>
                        {intl.formatMessage({id: "main.modules"})}
                        {!mobile && permissions.Designer &&
                            <Plus onClick={() => this.handleOpen('create')}>
                                <Add />
                            </Plus>
                        }
                    </Title>
                    {!!this.props.modules.length &&
                        <Modules
                            order={this.props.modules.map(item => item.id)}
                            modules={this.props.modules}
                            currentModule={currentModule && currentModule.id}
                            mobile={mobile}
                            permissions={permissions.Designer}
                            handleOpen={this.handleOpen}
                            onReorderModules={this.props.onReorderModules}
                            // updating={updating}
							search={this.props.search}
							resetFilter={this.props.resetFilter}
                        />
                    }
                </Container>
                <Dialog
                    fullWidth={this.state.open ? true : false}
                    open={Boolean(this.state.open || this.state.delete)}
                    onClose={this.handleClose}
                >
                    {this.state.open &&
                        <ModuleConfig
                            createModule={(config) => this.props.createModule({...config, layout: []})}
                            deleteModule={this.handleOpenConfirmation}
                            editModule={(config) => this.props.updateModule({...config, id: currentModule.id, layout: currentModule.layout})}
                            handleClose={this.handleClose}
                            name={this.state.open === 'edit' ? currentModule.name : ''}
                            icon={this.state.open === 'edit' ? currentModule.icon : null}
                            default={this.state.open === 'edit' ? currentModule.isDefault : false}
                            edit={this.state.open === 'edit'}
                            count={this.props.modules.length}
                        />
                    }
                    {this.state.delete &&
                        <Confirmation
							handleConfirm={() => this.handleDelete(currentModule.id)}
                            handleClose={this.handleClose}
                            text={intl.formatMessage({id: "main.confirm_delete_module_text"})}
                        />
                    }
                </Dialog>
            </React.Fragment>
        )
    }
}

export default injectIntl(ModulesList)
